import React from 'react';
import { heritageColors } from '../../../../heritageTheme.ts';

const TYPE_CONFIGS = {
  medic: { label: 'חובש', icon: 'medical_services', color: '#D32F2F', bg: '#FFEBEE' },
  paramedic: { label: 'פרמדיק', icon: 'cardiology', color: '#C62828', bg: '#FFCDD2' },
  maar: { label: 'מע"ר', icon: 'healing', color: '#B71C1C', bg: '#FFE0E0' },
};

/**
 * Columns – תבנית רשת אופקית עם מספר עמודות ניתן להגדרה
 * כל כונן בכרטיס מסודר ברשת – מתאים למידות גדולות ורחבות
 * ה-prop columns קובע את מספר העמודות (ברירת מחדל 3)
 */
const Columns = ({
  initialData = { volunteers: { medic: [], paramedic: [], maar: [] } },
  title = 'חירום והצלה',
  showTitle = true,
  columns = 3,
}) => {
  const volunteers = initialData.volunteers || { medic: [], paramedic: [], maar: [] };
  const colCount = Math.max(1, Math.min(6, columns));

  const allVolunteers = [
    ...(volunteers.medic || []).map(v => ({ ...v, type: 'medic' })),
    ...(volunteers.paramedic || []).map(v => ({ ...v, type: 'paramedic' })),
    ...(volunteers.maar || []).map(v => ({ ...v, type: 'maar' })),
  ];

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.emergency}`,
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
        }}>
          <div style={{
            backgroundColor: heritageColors.emergencyLight,
            borderRadius: '50%',
            padding: '0.3125em',
            display: 'flex',
            border: `0.03125em solid ${heritageColors.emergency}30`,
          }}>
            <span className="material-symbols-outlined" style={{
              color: heritageColors.emergency,
              fontSize: '1.125em',
            }}>ambulance</span>
          </div>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.emergency,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {allVolunteers.length === 0 ? (
        <div style={{ color: heritageColors.emergency, fontSize: '0.875em', textAlign: 'center' }}>
          אין כוננים זמינים
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${colCount}, 1fr)`,
          gap: '0.625em',
          flex: 1,
          alignContent: 'start',
        }}>
          {allVolunteers.map((v, index) => {
            const config = TYPE_CONFIGS[v.type] || { label: 'כונן', icon: 'support', color: '#D32F2F', bg: '#FFEBEE' };
            return (
              <div
                key={v.id || index}
                style={{
                  backgroundColor: '#fff',
                  border: `0.03125em solid ${heritageColors.border}`,
                  borderTop: `0.1875em solid ${config.color}`,
                  borderRadius: '0.375em',
                  padding: '0.75em',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.3125em',
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.3125em',
                }}>
                  <span className="material-symbols-outlined" style={{
                    color: config.color,
                    fontSize: '0.875em',
                  }}>{config.icon}</span>
                  <span style={{
                    fontSize: '0.625em',
                    color: config.color,
                    fontWeight: 700,
                    backgroundColor: config.bg,
                    padding: '0.125em 0.375em',
                    borderRadius: '0.1875em',
                  }}>
                    {config.label}
                  </span>
                </div>

                <div style={{
                  fontSize: '0.875em',
                  color: heritageColors.navy,
                  fontWeight: 'bold',
                }}>
                  {v.name}
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.25em',
                  color: heritageColors.emergency,
                  fontSize: '0.75em',
                  fontWeight: 'bold',
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '0.875em' }}>call</span>
                  <span style={{ direction: 'ltr' }}>{v.phone}</span>
                </div>

                {v.address && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25em',
                    color: heritageColors.slate,
                    fontSize: '0.6875em',
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '0.75em' }}>location_on</span>
                    {v.address}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Columns;
